/**
 * =====================================================================================================
 * NOTA:: esta clase se utiliza en el neubox-v4, si se realiza alguna modificación, actualizar neubox-v4
 * =====================================================================================================
 */

class NBXCookies {
  constructor(prefijo = null) {
    // validamos si esta en servidor de desarrollo,
    const hostname = window.location.hostname;
    const localhost = String(hostname).includes("localhost");

    if (localhost) {
      this.domainCookie = "localhost";
    } else {
      const tld = String(hostname).includes(".xyz") ? ".xyz" : ".com";
      this.domainCookie = ".neubox" + tld;
    }

    this.prefijo = "nbx" + (prefijo ? prefijo + "_" : "");
  }

  add(id_prefijo, value) {
    // domain={this.domainCookie}: Permite que la cookie sea compartida entre todos los subdominios de {this.domainCookie}.
    // path=/: Asegura que sea accesible en todas las rutas.
    // Secure: Hace que la cookie solo sea transmitida en conexiones HTTPS.
    // SameSite=Lax: Permite el acceso cruzado entre subdominios de forma segura.
    document.cookie = this.prefijo + id_prefijo + "=" + value + "; path=/; domain=" + this.domainCookie + "; Secure; SameSite=Lax";
  }

  getAll() {
    const regex = new RegExp(this.prefijo, "gi");
    const cookies = document.cookie.split(";").reduce((acc, cookie) => {
      const [key, value] = cookie.split("=").map((c) => c.trim());
      if (String(key).includes(this.prefijo)) {
        const id_prefijo = String(key).replace(regex, "");
        acc[id_prefijo] = value;
      }
      return acc;
    }, {});

    return cookies;
  }

  get(id_prefijo) {
    let cookies = this.getAll();

    for (const idPrefijo in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, idPrefijo)) {
        const value = cookies[idPrefijo];
        if (idPrefijo === id_prefijo) {
          return value;
        }
      }
    }
    return null;
  }

  delete(id_prefijo) {
    document.cookie =
      this.prefijo + id_prefijo + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + this.domainCookie + "; Secure; SameSite=Lax";
  }

  deleteAll() {
    const cookies = this.getAll();

    for (const idPrefijo in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, idPrefijo)) {
        this.delete(idPrefijo);
      }
    }
  }
}

class NBXDomain {
  constructor() {
    this.cookies = new NBXCookies("domain");
    this.separator = "_";
  }

  /**
   * agrega dominio a las cookies
   * @param {string} domain "slt.tld"
   * @param {string} type "register|transfer"
   * @param {int|string} years 1-10
   */
  add(domain, type = "register", years = 1) {
    this.cookies.add(domain, type + this.separator + years);
  }

  /**
   * obtiene el objeto del dominio, o retorna false si no lo encuentra
   * @param {string} domain
   * @returns {Object|bool} {dominio: (string), type: (string), years: (int)}|false
   */
  get(domain) {
    const domains = this.getAll();
    const domainFilter = domains.filter((item) => item.domain === domain);
    return domainFilter.length > 0 ? domainFilter[0] : false;
  }

  /**
   * retorna array de dominios guardados en cookie
   * @returns {array} [{domain: "sld.tld", type: "register|transfer", years: 1-10},...]
   */
  getAll() {
    const domains = [];
    const cookies = this.cookies.getAll();

    for (const domain in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, domain)) {
        const value = cookies[domain].split(this.separator);
        if (value.length == 2) {
          domains.push({ domain, type: value[0], years: parseInt(value[1]) });
        }
      }
    }

    return domains;
  }

  /**
   * Elimina dominio de las cookies
   * @param {string} domain
   */
  delete(domain) {
    this.cookies.delete(domain);
  }

  /**
   * elimina todos los dominios almacenados
   */
  deleteAll() {
    this.cookies.deleteAll();
  }

  /**
   * valida si existe el dominio en la cookie
   * @param {string} domain
   * @returns {bool}
   */
  exist(domain) {
    const resp = this.get(domain);
    return resp !== false;
  }

  /**
   * Obtiene el total de dominios guardados
   */
  total() {
    return this.getAll().length || 0;
  }
}

class NBXDeletedDomain {
  constructor() {
    this.cookies = new NBXCookies("DDomain");
    this.separator = "_";
  }

  /**
   * agrega dominio a las cookies
   * @param {string} domain "slt.tld"
   * @param {string} type "register|transfer"
   * @param {int|string} years 1-10
   */
  add(domain, type = "register", years = 1) {
    this.cookies.add(domain, type + this.separator + years);
  }

  /**
   * obtiene el objeto del dominio, o retorna false si no lo encuentra
   * @param {string} domain
   * @returns {Object|bool} {dominio: (string), type: (string), years: (int)}|false
   */
  get(domain) {
    const domains = this.getAll();
    const domainFilter = domains.filter((item) => item.domain === domain);
    return domainFilter.length > 0 ? domainFilter[0] : false;
  }

  /**
   * retorna array de dominios guardados en cookie
   * @returns {array} [{domain: "sld.tld", type: "register|transfer", years: 1-10},...]
   */
  getAll() {
    const domains = [];
    const cookies = this.cookies.getAll();

    for (const domain in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, domain)) {
        const value = cookies[domain].split(this.separator);
        if (value.length == 2) {
          domains.push({ domain, type: value[0], years: parseInt(value[1]) });
        }
      }
    }

    return domains;
  }

  /**
   * Elimina dominio de las cookies
   * @param {string} domain
   */
  delete(domain) {
    this.cookies.delete(domain);
  }

  /**
   * elimina todos los dominios almacenados
   */
  deleteAll() {
    this.cookies.deleteAll();
  }

  /**
   * valida si existe el dominio en la cookie
   * @param {string} domain
   * @returns {bool}
   */
  exist(domain) {
    const resp = this.get(domain);
    return resp !== false;
  }

  /**
   * Obtiene el total de dominios guardados
   */
  total() {
    return this.getAll().length || 0;
  }
}

class NBXDeletedDomainCart {
  constructor() {
    this.cookies = new NBXCookies("DCDomain");
    this.separator = "_";
  }

  /**
   * agrega dominio a las cookies
   * @param {string} domain "slt.tld"
   * @param {string} type "register|transfer"
   * @param {int|string} years 1-10
   */
  add(domain, type = "register", years = 1) {
    this.cookies.add(domain, type + this.separator + years);
  }

  /**
   * obtiene el objeto del dominio, o retorna false si no lo encuentra
   * @param {string} domain
   * @returns {Object|bool} {dominio: (string), type: (string), years: (int)}|false
   */
  get(domain) {
    const domains = this.getAll();
    const domainFilter = domains.filter((item) => item.domain === domain);
    return domainFilter.length > 0 ? domainFilter[0] : false;
  }

  /**
   * retorna array de dominios guardados en cookie
   * @returns {array} [{domain: "sld.tld", type: "register|transfer", years: 1-10},...]
   */
  getAll() {
    const domains = [];
    const cookies = this.cookies.getAll();

    for (const domain in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, domain)) {
        const value = cookies[domain].split(this.separator);
        if (value.length == 2) {
          domains.push({ domain, type: value[0], years: parseInt(value[1]) });
        }
      }
    }

    return domains;
  }

  /**
   * Elimina dominio de las cookies
   * @param {string} domain
   */
  delete(domain) {
    this.cookies.delete(domain);
  }

  /**
   * elimina todos los dominios almacenados
   */
  deleteAll() {
    this.cookies.deleteAll();
  }

  /**
   * valida si existe el dominio en la cookie
   * @param {string} domain
   * @returns {bool}
   */
  exist(domain) {
    const resp = this.get(domain);
    return resp !== false;
  }

  /**
   * Obtiene el total de dominios guardados
   */
  total() {
    return this.getAll().length || 0;
  }
}

class NBXDomainInCart {
  constructor() {
    this.cookies = new NBXCookies("cartdomain");
    this.separator = "_";
  }

  /**
   * agrega dominio a las cookies
   * @param {string} domain "slt.tld"
   * @param {string} type "register|transfer"
   * @param {int|string} years 1-10
   */
  add(domain, type = "register", periodo = 1) {
    this.cookies.add(domain, type + this.separator + periodo);
  }

  /**
   * obtiene el objeto del dominio, o retorna false si no lo encuentra
   * @param {string} domain
   * @returns {Object|bool} {dominio: (string), type: (string), years: (int)}|false
   */
  get(domain) {
    const domains = this.getAll();
    const domainFilter = domains.filter((item) => item.domain === domain);
    return domainFilter.length > 0 ? domainFilter[0] : false;
  }

  /**
   * retorna array de dominios guardados en cookie
   * @returns {array} [domain, domain...]
   */
  getAll() {
    const domains = [];
    const cookies = this.cookies.getAll();

    for (const domain in cookies) {
      if (Object.prototype.hasOwnProperty.call(cookies, domain)) {
        const value = cookies[domain].split(this.separator);
        if (value.length == 2) {
          const type = value[0];
          const regperiod = value[1];
          domains.push({ domain, type, regperiod });
        }
      }
    }

    return domains;
  }

  /**
   * Elimina dominio de las cookies
   * @param {string} domain
   */
  delete(domain) {
    this.cookies.delete(domain);
  }

  /**
   * elimina todos los dominios almacenados
   */
  deleteAll() {
    this.cookies.deleteAll();
  }

  /**
   * valida si existe el dominio en la cookie
   * @param {string} domain
   * @returns {bool}
   */
  exist(domain) {
    const resp = this.get(domain);
    return resp !== false;
  }

  /**
   * Obtiene el total de dominios guardados
   */
  total() {
    return this.getAll().length || 0;
  }

  /**
   * retorna array de dominios de tipo "register"
   * @returns {array}
   */
  getRegisterDomains() {
    const domains = this.getAll();
    const filterDomains = domains.filter((item) => item.type === "register");
    return filterDomains;
  }

  /**
   * retorna array de dominios de tipo "transfer"
   * @returns {array}
   */
  getTransferDomains() {
    const domains = this.getAll();
    const filterDomains = domains.filter((item) => item.type === "transfer");
    return filterDomains;
  }
}

class NBXCartCount {
  constructor() {
    this.cookies = new NBXCookies();
    this.NBXDomain = new NBXDomain();
    this.NBXDeletedDomain = new NBXDeletedDomain();
    this.id_prefijo = "count_cart";
  }

  /**
   *  agrega/actualiza el contador de items agregados en carrito.neubox.com
   * @param {int/string} total
   */
  add(total) {
    this.cookies.add(this.id_prefijo, total);
  }

  /**
   * Obtiene el total de items en el carrito, tomando en cuenta los items agregados
   * en carrito.neubox.com, neubox.com y lo items eliminados desde neubox.com
   * @returns {int}
   */
  total() {
    const totalCarrito = this.cookies.get(this.id_prefijo) || 0;
    const totalDomainsV4 = this.NBXDomain.total();
    const totalDeleted = this.NBXDeletedDomain.total();

    return parseInt(totalCarrito) + totalDomainsV4 - totalDeleted;
  }
}

// instancia de classes en elemento window
window.NBXCookies = new NBXCookies();
window.NBXDomain = new NBXDomain();
window.NBXDeletedDomain = new NBXDeletedDomain();
window.NBXDeletedDomainCart = new NBXDeletedDomainCart();
window.NBXDomainInCart = new NBXDomainInCart();
window.NBXCartCount = new NBXCartCount();
